// routePaths.ts
export const HOME_ROUTE = '/';
export const COURSE_BASE_ROUTE = '/course/';
export const COURSE_ROUTE = `${COURSE_BASE_ROUTE}:courseId`;
export const MY_UPLOAD_ID = Number.MAX_SAFE_INTEGER;
export const MY_UPLOAD_RESOURCE_ROUTE = `${COURSE_BASE_ROUTE}${MY_UPLOAD_ID}`;
export const PROFILE_ROUTE = '/user/profile';
export const UPLOAD_ROUTE = '/user/upload';
export const ORDERS_ROUTE = '/user/orders';
export const PAYMENT_RETURN_ROUTE = '/payment/return';